module.exports = __webpack_public_path__ + "1f7ed5975ffc4a2f75a8094edc03e573.svg";